import React from 'react';
import SkeletonBone from './SkeletonBone';
import './loading.css';

const SkeletonAgent = ({ compact = false }) => (
  <div className="skeleton-agent" aria-hidden="true">
    <SkeletonBone
      circle
      className="skeleton-agent__avatar"
      style={compact ? { width: 64, height: 64 } : undefined}
    />
    <SkeletonBone className="skeleton-agent__name" />
    <SkeletonBone className="skeleton-agent__title" />
    {!compact && (
      <>
        <SkeletonBone className="skeleton-agent__line" />
        <SkeletonBone className="skeleton-agent__line" style={{ width: '65%' }} />
        <SkeletonBone className="skeleton-agent__button" />
      </>
    )}
  </div>
);

export const SkeletonAgentGrid = ({ count = 6 }) => (
  <div className="skeleton-agent-grid" aria-busy="true" aria-live="polite">
    {Array.from({ length: count }, (_, index) => (
      <SkeletonAgent key={index} />
    ))}
  </div>
);

export default SkeletonAgent;
